import { Action } from "@radix-ui/react-alert-dialog";

import React from "react";

type AlertActionProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

const AlertAction = React.forwardRef<HTMLButtonElement, AlertActionProps>(
  (props, forwardedRef) => {
    const { children, onClick, ...rest } = props;
    return (
      <Action {...rest} asChild onClick={onClick} ref={forwardedRef}>
        {children}
      </Action>
    );
  },
);

AlertAction.displayName = "AlertAction";

export { AlertAction };
